import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IonLoading } from '@ionic/react';
import { PageLayout } from 'containers/layout';
import ReceiptActions, { ReceiptSelectors } from 'redux/ReceiptRedux';
import ReceiptDetail from 'containers/receipts/ReceiptDetail';

function ReceiptView() {
  const params = useParams();
  const dispatch = useDispatch();
  const currentReceipt = useSelector(ReceiptSelectors.selectCurrentReceipt);
  const loading = useSelector(ReceiptSelectors.selectCurrentReceiptLoading);

  useEffect(() => {
    if (params.receiptId) {
      dispatch(ReceiptActions.loadCurrentReceipt(params.receiptId));
    }
  }, [params.receiptId]);

  return (
    <PageLayout title="Receipt" back="/receipts">
      <IonLoading isOpen={loading} message="Loading..." />
      {currentReceipt && <ReceiptDetail receipt={currentReceipt} />}
    </PageLayout>
  );
}

export default ReceiptView;
